// extracted by mini-css-extract-plugin
export default {"card":"_7-z"};